import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	backlogListName: {
		id: 'backlog.card-list.backlog-list-name',
		defaultMessage: 'Backlog',
		description: '',
	},
	boardListName: {
		id: 'backlog.card-list.board-list-name',
		defaultMessage: 'Board',
		description: '',
	},
	cardAmount: {
		id: 'backlog.card-list.card-amount',
		defaultMessage: '{cardAmount} {cardAmount, plural, one {issue} other {issues}}',
		description: '',
	},
	visibleCardAmount: {
		id: 'backlog.card-list.visible-card-amount',
		defaultMessage:
			'{cardAmount} of {totalCardAmount} {totalCardAmount, plural, one {issue} other {issues}} visible',
		description: '',
	},
	emptyListFiltered: {
		id: 'backlog.card-list.empty-list-filtered',
		defaultMessage: 'There are no issues that match your current filter.',
		description: '',
	},
	emptyBoard: {
		id: 'backlog.card-list.empty-board',
		defaultMessage: 'There are no issues on the board.',
		description: '',
	},
	emptyBacklog: {
		id: 'backlog.card-list.empty-backlog',
		defaultMessage: 'Your backlog is empty.',
		description: '',
	},
	emptyNotStartedSprint: {
		id: 'backlog.card-list.empty-not-started-sprint',
		defaultMessage:
			'Plan a sprint by dragging the sprint footer down below some issues, or by dragging issues here.',
		description: '',
	},
	emptyStartedSprint: {
		id: 'backlog.card-list.empty-started-sprint',
		defaultMessage: 'There are no issues in this sprint.',
		description: '',
	},
	startSprint: {
		id: 'backlog.card-list.start-sprint',
		defaultMessage: 'Start sprint',
		description: '',
	},
	createSprint: {
		id: 'backlog.card-list.create-sprint',
		defaultMessage: 'Create sprint',
		description: 'Create sprint button on the next-gen backlog',
	},
	completeSprint: {
		id: 'backlog.card-list.complete-sprint',
		defaultMessage: 'Complete sprint',
		description: 'Complete sprint button text',
	},
	addSprintDates: {
		id: 'backlog.card-list.add-sprint-dates',
		defaultMessage: 'Add dates',
		description: 'Add sprint dates button text',
	},
	disabledStartSprintButtonEmpty: {
		id: 'backlog.card-list.disabled-start-sprint-button-empty',
		defaultMessage: 'Sprint cannot be started because it contains no issues',
		description: '',
	},
	disabledStartSprintButtonNoParallel: {
		id: 'backlog.card-list.disabled-start-sprint-button-no-parallel',
		defaultMessage: 'Can be planned but not started until the completion of above active sprint',
		description: '',
	},
	createdSprintAriaLive: {
		id: 'backlog.card-list.created-sprint-aria-live',
		defaultMessage: '{sprintName} created',
		description: 'Message for screen readers when creating a sprint',
	},
	inlineCardCreateAriaLabel: {
		id: 'backlog.card-list.inline-card-create-aria-label',
		defaultMessage: 'Create issue for {sprintName}',
		description: 'Aria label for each create issue inline button',
	},
	sprintListNamePrefix: {
		id: 'backlog.card-list.sprint-list-name-prefix',
		defaultMessage: 'sprint',
		description: '',
	},
	emptyListFilteredIssueTermRefresh: {
		id: 'backlog.card-list.empty-list-filtered-issue-term-refresh',
		defaultMessage: "There's nothing that matches this filter",
		description: '',
	},
	emptyBoardIssueTermRefresh: {
		id: 'backlog.card-list.empty-board-issue-term-refresh',
		defaultMessage: "There's nothing on this board",
		description: '',
	},
	emptyNotStartedSprintIssueTermRefresh: {
		id: 'backlog.card-list.empty-not-started-sprint-issue-term-refresh',
		defaultMessage:
			'Plan a sprint by dragging work items into it, or by dragging the sprint footer.',
		description: '',
	},
	emptyStartedSprintIssueTermRefresh: {
		id: 'backlog.card-list.empty-started-sprint-issue-term-refresh',
		defaultMessage: "There's nothing in this sprint",
		description: '',
	},
	disabledStartSprintButtonEmptyIssueTermRefresh: {
		id: 'backlog.card-list.disabled-start-sprint-button-empty-issue-term-refresh',
		defaultMessage: "The sprint can't be started because it contains no work items",
		description: '',
	},
	inlineCardCreateAriaLabelIssueTermRefresh: {
		id: 'backlog.card-list.inline-card-create-aria-label-issue-term-refresh',
		defaultMessage: 'Create work items for {sprintName}',
		description: 'Aria label for each create issue inline button',
	},
	visibleCardAmountIssueTermRefresh: {
		id: 'backlog.card-list.visible-card-amount-issue-term-refresh',
		defaultMessage:
			'{cardAmount} of {totalCardAmount} {totalCardAmount, plural, one {work item} other {work items}} visible',
		description: '',
	},
	cardAmountIssueTermRefresh: {
		id: 'backlog.card-list.card-amount-issue-term-refresh',
		defaultMessage: '{cardAmount} {cardAmount, plural, one {work item} other {work items}}',
		description: '',
	},
});
